import { FC, PropsWithChildren } from "react";

import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import { FileMagnifyingGlassIcon } from "@phosphor-icons/react/dist/csr/FileMagnifyingGlass";

interface EmptyContainerProps extends PropsWithChildren {
  title?: string;
  small?: boolean;
}

export const EmptyContainer: FC<EmptyContainerProps> = ({ title = "No Files", small = false }) => (
  <Box
    sx={{
      width: "100%",
      height: small ? "200px" : "400px",
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      flexDirection: "column",
    }}
  >
    <FileMagnifyingGlassIcon color="disabled" size="10em" />
    <Typography data-cy="empty-container-message">{title}</Typography>
  </Box>
);
